import { service } from '../../../service';

const state = {
  loading: false,
  jobs: [],
  bookings: [],
  paginatedItems: {
    job: {
      docs: [],
      totalDocs: 0,
      offset: 0,
      limit: 30,
      totalPages: 1,
      page: 1,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
    },
  },
};

const actions = {
  fetchJobs({ commit, rootState }, { start, end }) {
    commit('setLoading', true);

    return service
      .get(
        `/jobs/${rootState.account.company._id}/${rootState.account.location._id}?start=${start}&end=${end}`
      )
      .then((result) => commit('setJobs', result.jobs));
  },

  fetchJobById({ commit, rootState }, id) {
    commit('setLoading', true);

    return service
      .get(
        `/jobs/${rootState.account.company._id}/${rootState.account.location._id}/${id}`
      )
      .then((result) => {
        commit('setLoading', false);
        return result;
      });
  },

  fetchBookings({ commit, rootState }, { start, end }) {
    commit('setLoading', true);

    return service
      .get(
        `/bookings/${rootState.account.company._id}/${rootState.account.location._id}?start=${start}&end=${end}`
      )
      .then((result) => commit('setJobs', result.jobs));
  },

  async createJob({ dispatch, commit, rootState }, payload) {
    commit('setLoading', true);

    return service
      .post(
        `/jobs/${rootState.account.company._id}/${rootState.account.location._id}`,
        payload
      )
      .then((result) => {
        commit('newJob', result.job);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  async updateJob({ dispatch, commit, rootState }, payload) {
    return service
      .patch(`/jobs/${rootState.account.company._id}/${payload._id}`, payload)
      .then((result) => {
        commit('updateJob', result.job);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  deleteJob({ dispatch, commit, rootState }, id) {
    return service
      .delete(`/jobs/${rootState.account.company._id}/${id}`)
      .then((result) => {
        commit('deleteJob', result.id);
        dispatch('alert/success', result.message, { root: true });
      });
  },

  addCandidateToJob(
    { dispatch, commit, rootState },
    { job, bookings, candidate }
  ) {
    commit('setLoading', true);

    return service
      .post(
        `/jobs/${rootState.account.company._id}/${rootState.account.location._id}/${job}/candidates`,
        { ...candidate, bookings }
      )
      .then((result) => {
        commit('updateJob', result.job);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  async updateCandidateBooking(
    { dispatch, commit, rootState },
    { job, booking, candidate }
  ) {
    return service
      .patch(
        `/jobs/${rootState.account.company._id}/${job._id}/${booking._id}/${candidate._id}`,
        { candidate, booking, job }
      )
      .then((result) => {
        console.log(result);
        commit('updateJob', result.job);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },

  async fetchAllJobsPaginated({ commit, rootState }, data) {
    commit('setLoading', true);

    var url = `/jobs/company/${rootState.account.company._id}/location/${rootState.account.location._id}`;
    url = url.params(data);
    return service.get(url).then((result) => {
      commit('setPaginatedItems', result);
    });
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setJobs(state, jobs) {
    state.jobs = jobs;
    state.loading = false;
  },
  setPaginatedItems(state, jobs) {
    state.paginatedItems = jobs;
    state.loading = false;
  },
  newJob(state, job) {
    state.jobs.push(job);
    state.paginatedItems.job.docs.push(job);
    state.loading = false;
  },
  updateJob(state, job) {
    var index = state.jobs.findIndex((item) => {
      return item._id === job._id;
    });
    if (index !== -1) {
      state.jobs.splice(index, 1, job);
    }

    index = state.paginatedItems.job.docs.findIndex((item) => {
      return item._id === job._id;
    });
    if (index !== -1) {
      state.paginatedItems.job.docs.splice(index, 1, job);
    }
    state.loading = false;
  },
  deleteJob(state, id) {
    var index = state.jobs.findIndex((item) => {
      return item._id === id;
    });
    if (index !== -1) {
      state.jobs.splice(index, 1);
    }

    index = state.paginatedItems.job.docs.findIndex((item) => {
      return item._id === id;
    });
    if (index !== -1) {
      state.paginatedItems.job.docs.splice(index, 1);
    }
    state.loading = false;
  },
  setBookings(state, bookings) {
    state.bookings = bookings;
    state.loading = false;
  },
  // newJob(state, booking) {
  //   state.bookings.push(booking);
  //   state.loading = false;
  // },
  // updateJob(state, booking) {
  //   var index = state.bookings.findIndex(item => {
  //     return item._id === booking._id;
  //   });
  //   if (index !== -1) {
  //     state.bookings.splice(index, 1, booking);
  //   }
  //   state.loading = false;
  // },
  // deleteJob(state, id) {
  //   var index = state.bookings.findIndex(item => {
  //     return item._id === id;
  //   });
  //   if (index !== -1) {
  //     state.bookings.splice(index, 1);
  //   }
  //   state.loading = false;
  // }
};

export const planner = {
  namespaced: true,
  state,
  actions,
  mutations,
};
